// extracted by css-extract-rspack-plugin
export default {"TargetTrigger":"RJjqe","groupLabel":"MvMHy"};